import { render, staticRenderFns } from "./NewPassSunat.vue?vue&type=template&id=c48c7282&scoped=true&"
import script from "./NewPassSunat.vue?vue&type=script&lang=ts&"
export * from "./NewPassSunat.vue?vue&type=script&lang=ts&"
import style0 from "./NewPassSunat.vue?vue&type=style&index=0&id=c48c7282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48c7282",
  null
  
)

export default component.exports